import MODULE from "@/flit2go-web-core/interfaces/moduleConstants";
import store from "@/flit2go-web-core/store/index";

import {
  BILLING,
  PAYMENTS,
  BRANCH_FORM,
  BRANCH_LIST,
  CORPORATE_NETWORKS,
  CORPORATE_NETWORKS_FORM,
  OWNERS,
  OWNERS_DETAIL,
  OWNERS_HOME,
  PARKING_FORM,
  PARKING_LIST,
  PROMOTIONS,
  PROMOTIONS_FORM,
  RATE,
  RATE_TYPES,
  SUPPORT_PHONE_NUMBERS,
  SUPPORT_PHONE_NUMBERS_FORM,
  ZONES,
  ZONES_CREATE,
  REPORTS,
  AGENCY_LIST,
  AGENCY_FORM,
  COLLECTION_LIST,
} from "@/modules/Owners/routesInterface";

const menu = {
  code: MODULE.OWNERS.CODE,
  name: "owners",
  label: "common.owner",
  link: OWNERS_HOME,
  children: [],
  createChildren: [],
};

const submenus = [
  {
    code: MODULE.OWNERS.DASHBOARD,
    icon: "dashboard",
    label: "common.dashboard",
    link: OWNERS_HOME,
    name: "home",
    tooltip: "common.home",
  },
  {
    code: MODULE.OWNERS.BRANCHES,
    icon: "branch",
    label: "common.branches",
    link: BRANCH_LIST,
    name: "branch",
    tooltip: "common.branches",
  },
  {
    code: MODULE.OWNERS.PARKINGS,
    icon: "parking",
    label: "common.parkings",
    link: PARKING_LIST,
    name: "parking",
    tooltip: "common.parkings",
  },
  {
    code: MODULE.OWNERS.ZONES,
    icon: "zone",
    label: "common.zones",
    link: ZONES,
    name: "zones",
    tooltip: "common.zones",
  },
  {
    code: MODULE.OWNERS.PRICING,
    icon: "pricing",
    label: "common.rates",
    link: RATE,
    name: "rates",
    tooltip: "common.rates",
  },
  {
    code: MODULE.OWNERS.PROMOTIONS,
    icon: "on-sale-sticker-1",
    label: "common.promotions",
    link: PROMOTIONS,
    name: "promotions",
    tooltip: "common.promotions",
  },
  {
    code: MODULE.OWNERS.CORPORATE_NETWORKS,
    icon: "corporate-network",
    label: "common.corporateNetworks",
    link: CORPORATE_NETWORKS,
    name: "corporateNetwork",
    tooltip: "common.corporateNetworks",
  },
  {
    code: MODULE.OWNERS.SUPPORT_PHONES,
    icon: "phone",
    label: "common.supportPhoneNumbers",
    link: SUPPORT_PHONE_NUMBERS,
    name: "supportPhoneNumbers",
    tooltip: "common.supportPhoneNumbers",
  },
  {
    code: MODULE.OWNERS.PAYMENTS,
    icon: "coins-plus",
    label: "charges",
    link: PAYMENTS,
    name: "charges",
    tooltip: "charges",
  },
  {
    code: MODULE.OWNERS.BILLING,
    icon: "paper-money",
    label: "common.accounting",
    link: BILLING,
    name: "billing",
    tooltip: "common.accounting",
  },
  {
    code: MODULE.OWNERS.REPORTS,
    icon: "statistics",
    label: "reports",
    link: REPORTS,
    name: "reports",
    tooltip: "reports",
  },
  {
    code: MODULE.OWNERS.AGENCIES,
    icon: "agency",
    label: "agencies",
    link: AGENCY_LIST,
    name: "agency",
    tooltip: "agencies",
  },
  {
    code: MODULE.OWNERS.COLLECTION,
    icon: "billing",
    label: "collections",
    link: COLLECTION_LIST,
    name: "collection",
    tooltip: "collections",
  },
];

const submenusCreate = [
  {
    code: MODULE.OWNERS.BRANCHES,
    name: "Branch",
    label: "common.branch",
    link: BRANCH_FORM,
  },
  {
    code: MODULE.OWNERS.PARKINGS,
    name: "Parking",
    label: "common.parking",
    link: PARKING_FORM,
  },
  {
    code: MODULE.OWNERS.ZONES,
    name: "Zone",
    label: "common.zone",
    link: ZONES_CREATE,
  },
  {
    code: MODULE.OWNERS.PRICING,
    name: "Rate",
    label: "common.rate",
    link: RATE_TYPES,
  },
  {
    code: MODULE.OWNERS.PROMOTIONS,
    name: "Promotion",
    label: "common.promotion",
    link: PROMOTIONS_FORM,
  },
  {
    code: MODULE.OWNERS.CORPORATE_NETWORKS,
    name: "corporateNetwork",
    label: "common.corporateNetworks",
    link: CORPORATE_NETWORKS_FORM,
  },
  {
    code: MODULE.OWNERS.SUPPORT_PHONES,
    name: "supportPhoneNumber",
    label: "common.supportPhoneNumber",
    link: SUPPORT_PHONE_NUMBERS_FORM,
  },
  {
    code: MODULE.OWNERS.AGENCIES,
    icon: "agency",
    label: "agency",
    link: AGENCY_FORM,
    name: "agency",
    tooltip: "agency",
  },
];

// ESTO SE EJECUTA AL INICIAR SESIÓN, LO DE ARRIBA NO
function getMenu(submodules) {
  const isSuperOwner = store.getters["auth/isSuperOwner"];
  checkSuperOwnerMenu(isSuperOwner);
  menu.children = [];
  menu.createChildren = [];
  submodules.forEach((submodule) => {
    const submenuAux = submenus.find(
      (submenu) => submenu.code === submodule.code,
    );
    const submenuCreateAux = submenusCreate.find(
      (submenu) => submenu.code === submodule.code,
    );
    if (submenuAux && (submodule.r || submodule.w)) {
      menu.children.push(submenuAux);
    }
    if (submenuCreateAux && submodule.w && !submodule.hasFilter) {
      menu.createChildren.push(submenuCreateAux);
    }
  });
  return menu;
}

function checkSuperOwnerMenu(isSuperOwner) {
  submenus.splice(1, 0, {
    code: MODULE.OWNERS.OWNERS,
    icon: "tribunal-1",
    label: isSuperOwner ? "common.owners" : "common.ownerDetail",
    link: isSuperOwner ? OWNERS : OWNERS_DETAIL,
    name: "detail",
    tooltip: isSuperOwner ? "common.owners" : "common.owner",
  });
}

export default { getMenu };
